var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13117 9.36938L8.13117 4.28221L8.13117 9.36938Z",
    fill: "#0045F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13117 9.36938L8.13117 4.28221",
    stroke: "white",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13117 29.718L8.13117 19.5437L8.13117 29.718Z",
    fill: "#0045F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13117 29.718L8.13117 19.5437",
    stroke: "white",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0335 14.4565L17.0335 4.28218L17.0335 14.4565Z",
    fill: "#0045F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0335 14.4565L17.0335 4.28218",
    stroke: "white",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0335 29.718L17.0335 25.9026L17.0335 29.718Z",
    fill: "#0045F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0335 29.718L17.0335 25.9026",
    stroke: "white",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9359 9.36938L25.9359 4.28221L25.9359 9.36938Z",
    fill: "#0045F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9359 9.36938L25.9359 4.28221",
    stroke: "white",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9359 29.718L25.9359 19.5437L25.9359 29.718Z",
    fill: "#0045F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9359 29.718L25.9359 19.5437",
    stroke: "white",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6741 11.913C10.6741 10.5082 9.53529 9.36936 8.1305 9.36936C6.72572 9.36936 5.58691 10.5082 5.58691 11.913C5.58691 13.3177 6.72572 14.4565 8.1305 14.4565C9.53529 14.4565 10.6741 13.3177 10.6741 11.913Z",
    fill: "#0045F5",
    stroke: "white",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5764 22.0873C19.5764 20.6825 18.4376 19.5437 17.0328 19.5437C15.6281 19.5437 14.4893 20.6825 14.4893 22.0873C14.4893 23.4921 15.6281 24.6309 17.0328 24.6309C18.4376 24.6309 19.5764 23.4921 19.5764 22.0873Z",
    fill: "#0045F5",
    stroke: "white",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4798 11.913C28.4798 10.5082 27.341 9.36936 25.9362 9.36936C24.5314 9.36936 23.3926 10.5082 23.3926 11.913C23.3926 13.3177 24.5314 14.4565 25.9362 14.4565C27.341 14.4565 28.4798 13.3177 28.4798 11.913Z",
    fill: "#0045F5",
    stroke: "white",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefine);
export default __webpack_public_path__ + "static/media/refine.c4f70fec6d0674b2bea83e3ab9281f44.svg";
export { ForwardRef as ReactComponent };